import React, { Component } from "react";
import PropTypes from "prop-types";
import { Steps } from "intro.js-react";

import "intro.js/introjs.css";
import { t } from "../../../utils/utils";

class Intro extends Component {
  constructor(props) {
    super(props);
    this.state = {
      initialStep: 0,
      steps: [
        {
          element: ".intro_step0",
          intro: t("introEditorPaso0"),
        },
        {
          element: ".intro_step1",
          intro: t("introEditorPaso1"),
          position: "right",
        },
        {
          element: ".intro_step2",
          intro: t("introEditorPaso2"),
          position: "top",
        },
        {
          element: ".intro_step3",
          intro: t("introEditorPaso3"),
          position: "right",
        },
        {
          element: ".intro_step4",
          intro: t("introEditorPaso4"),
          position: "right",
        },
        {
          element: ".intro_step5",
          intro: t("introEditorPaso5"),
          position: "auto",
        },
        {
          element: ".intro_step6",
          intro: t("introEditorPaso6"),
          position: "auto",
        },
        {
          element: ".intro_step7",
          intro: t("introEditorPaso7"),
          position: "auto",
        },
        {
          element: ".intro_step8",
          intro: t("introEditorPaso8"),
          position: "top",
        },
      ],
    };
  }
  render() {
    const { show, exit } = this.props;
    const { steps, initialStep } = this.state;

    return (
      <>
        <Steps
          enabled={show}
          steps={steps}
          initialStep={initialStep}
          onExit={exit}
        />
      </>
    );
  }
}

Intro.propTypes = {
  show: PropTypes.bool.isRequired,
};

Intro.defaultProps = {
  show: false,
};

export default Intro;
